import React from 'react';
import styled from 'styled-components'
import { theme } from 'styled-tools'
import useTranslation from '../../../utils/translation'

const Container = styled.div`
  height: 70px;
  text-align: center;
  width: 100%;
  display: block;
  background-color: ${theme('colors.primary')};
  color: ${theme('colors.backgroundPrimary')};
  font-weight: 600;
  padding: 25px;
  font-family: ${theme('typography.paragraph.fontFamily')};
  ${(props) => props.theme.media.min.sm`
    padding: 25px;
  `}
`

const LoggedInBanner = () => {
    const t = useTranslation('app.loggedin-banner')
    return (
        <Container>
            {t('text')}
        </Container>
    );
}

export default LoggedInBanner; 